export function mergeIframeImage() {
	document.querySelectorAll('#merge-iframe').forEach((target) => {
		const articleHtml = target.closest('.yn-article__html')
		if (!articleHtml) return

		const images = articleHtml.previousElementSibling
		if (!images || !images.classList.contains('yn-article__images')) return

		const figure = images.querySelector('figure')
		if (figure) {
			const img = figure.querySelector('img')
			if (img) figure.replaceChildren(img)
			images.replaceChildren(figure)
		}

		target.before(images)

		const ro = new ResizeObserver(() => {
			if (target.offsetHeight > 0) {
				images.style.maxHeight = target.offsetHeight + 'px'
				ro.disconnect()
			}
		})
		ro.observe(target)
	})
}
